import { KpiCard } from '@evi/ui';
import type { OperatorDashboardData } from '@evi/shared';
import { formatEnergy, formatPctDelta } from './_lib';

export default function KpiEnergy({ summary }: { summary: OperatorDashboardData | undefined }) {
  return (
    <KpiCard
      fit
      label="Energy (MTD)"
      value={summary ? formatEnergy(summary.energyMtdKwh.value) : '—'}
      delta={summary ? formatPctDelta(summary.energyMtdKwh.deltaPct) : undefined}
    />
  );
}
